import { render, staticRenderFns } from "./MainView.vue?vue&type=template&id=01146d74&scoped=true&"
import script from "./MainView.vue?vue&type=script&lang=js&"
export * from "./MainView.vue?vue&type=script&lang=js&"
import style0 from "./MainView.vue?vue&type=style&index=0&id=01146d74&prod&scoped=true&lang=scss&"
import style1 from "./MainView.vue?vue&type=style&index=1&id=01146d74&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01146d74",
  null
  
)

export default component.exports